export default __webpack_public_path__ + "static/banner-finance-getting-on-top-b2e39422dc6c4061ca1e3e4ad17be595.jpg";